import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { selfReturnManual } from "../../../actions/srActions";
import { getBranchList } from '../../../actions/commonAction';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const useStyles = makeStyles((theme) => ({
    root: {
        
    },
    containerStyle: { 
        display: "flex", 
        alignItems: "center",
        marginTop: 10
    },
    textFieldStyle: { 
        marginLeft: '20px', 
        width: 400 
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 20 
    },
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    },
}));

function MarkPosition() {
    const {t} = useTranslation('selfReturn');
    const classes = useStyles();
    const dispatch = useDispatch();

    const [branches, setBranches] = useState([]);
    const [branch, setBranch] = useState(1);
    const [tno, setTno] = useState('');
    const [failMsg, setFailMsg] = useState('');

    const handleWarehouse = (event) => {
        setBranch(event.target.value);
    };

    const handleTno = (event) => {
        setTno(event.target.value );
    };

    useEffect(() => {
        dispatch(getBranchList()).then((branches)=>{
            setBranches(branches);
        })
    }, [])

    function handleClick() {
        if(!tno) {
            setFailMsg(t('input_tno'));
            dispatch(showAlertSnackbar({message: t('input_tno'), type: 'warning'}))
        } else {
            dispatch(selfReturnManual(branch, tno))
            .then((res) => {
                dispatch(showAlertSnackbar({message: t('success'), type: 'success'}))
            })
            .catch((err) => {
                setFailMsg(err.message);
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
        }
    }

    return (
        <Fragment>
            <div className={classes.titleSize}>{t('mark_warehouse_position')}</div>
            <Grid container className={classes.containerStyle}>
                <Select
                    defaultValue={`1`}
                    displayEmpty
                    onChange={handleWarehouse}
                >
                    {
                        (branches).map((branch, index) => {
                            return <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                        })
                    }
                </Select>
                <TextField 
                    variant="outlined"
                    size="small"
                    placeholder={t('order_id')}
                    className={classes.textFieldStyle}
                    onChange={handleTno}
                />
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.buttonStyle}
                    onClick={handleClick}
                >
                    {t('mark')}
                </Button>
            </Grid>
        </Fragment>
    );
}

export default MarkPosition;